import { OnboardingItemKey } from "../../../common/enums";
import { IOnboardingFlow } from "./onboardingTypes";
import { buildFlow } from "./allSteps";

// All steps available to the Tenant (studio owner) role.
// To add/remove a step, edit this list. Step content lives in allSteps.ts.
const tenantStepIds: OnboardingItemKey[] = [
  OnboardingItemKey.GetToKnowPlanny,
  OnboardingItemKey.StudioProfile,
  OnboardingItemKey.StudioWizard,
  OnboardingItemKey.AddBillingData,
  OnboardingItemKey.PlanTypes,
  OnboardingItemKey.CreatePlan,
  OnboardingItemKey.PlanWizard,
  OnboardingItemKey.ServiceTypes,
  OnboardingItemKey.ClassCategories,
  OnboardingItemKey.HallTypes,       // Tenant-only: requires Tenant role to manage halls
  OnboardingItemKey.EmployeesList,
  OnboardingItemKey.EmployeeWizard,
  OnboardingItemKey.CreateEvent,
  OnboardingItemKey.EventWizard,
  OnboardingItemKey.EventWizardHybrid,
  OnboardingItemKey.ServiceWizardGuide,
  OnboardingItemKey.BlockedTimeGuide,
  OnboardingItemKey.FirstUser,
  OnboardingItemKey.UserAdd,
  OnboardingItemKey.UserProfile,
  OnboardingItemKey.DashboardKpis,
  OnboardingItemKey.Statistics,
  OnboardingItemKey.StatisticsDetail,
  OnboardingItemKey.Support,
  // Page Guides (hidden, component-driven)
  OnboardingItemKey.RefillCardGuide,
  OnboardingItemKey.RefillCardEmpty,
  OnboardingItemKey.InventoryGuide,
  OnboardingItemKey.InventoryOverviewGuide,
  OnboardingItemKey.InventoryTransfersGuide,
  OnboardingItemKey.CashdeskGuide,
  OnboardingItemKey.CashdeskEmpty,
  OnboardingItemKey.FamiliesGuide,
  OnboardingItemKey.BreakTypesGuide,
  OnboardingItemKey.GymVisitsGuide,
];

export const tenantFlow: IOnboardingFlow = buildFlow(tenantStepIds);
